import React from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'
import { EntityTableCell, useMediaQueryContext } from '@fourthwall/components'
import type { GiveawayPackage } from '@fourthwall/services/dist/GiftsApiClient'

import * as S from './GiveawayPackageListItem.styled'

type GiveawayPackageListItemProps = {
  giveawayPackage: GiveawayPackage
}

export const GiveawayPackageListItem = ({ giveawayPackage }: GiveawayPackageListItemProps) => {
  const media = useMediaQueryContext()

  return (
    <S.Container>
      <EntityTableCell
        top={giveawayPackage.items[0]?.name}
        image={
          <PhotoThumbnail
            url={giveawayPackage.items[0]?.image}
            size={media.tablet ? 'large' : 'extraLarge'}
          />
        }
        bottom={
          <div>
            {giveawayPackage.stats.usage.redeemed}/{giveawayPackage.stats.usage.all} used
          </div>
        }
      />
    </S.Container>
  )
}
